export const aboutContent = {
  brandName: '黑料不打烊',
  tagline: '全天候娱乐黑料聚合平台',
  intro: [
    '黑料不打烊成立于2024年，是国内领先的娱乐资讯聚合平台。我们致力于为"吃瓜群众"提供最快、最全、最劲爆的娱乐圈一手爆料。',
    '平台拥有一支专业的编辑团队和广泛的信息来源网络，24小时不间断监控全网娱乐动态，确保用户第一时间掌握娱乐圈最新热点。',
    '我们的宗旨是"不造谣、不信谣、不传谣，但绝不放过任何一个真实的瓜"。所有爆料内容均经过多方核实，力求在速度和真实性之间找到最佳平衡。',
  ],
  features: [
    {
      title: '7×24小时不间断更新',
      description: '无论深夜还是清晨，黑料不打烊始终在线，第一时间为你推送最新爆料。',
      icon: 'ri-timer-line',
    },
    {
      title: '全方位覆盖',
      description: '涵盖明星、网红、综艺、影视、音乐、体育等多个领域，一个平台看遍全娱乐圈。',
      icon: 'ri-radar-line',
    },
    {
      title: '真实可信',
      description: '所有爆料均经过多方核实，拒绝虚假信息和恶意炒作，为用户提供可信赖的内容。',
      icon: 'ri-shield-check-line',
    },
    {
      title: '吃瓜社区',
      description: '活跃的评论区让吃瓜不再孤单，与千万网友一起讨论最新热点，分享独家内幕。',
      icon: 'ri-chat-smile-2-line',
    },
  ],
  stats: [
    { value: '500万+', label: '日活用户' },
    { value: '10000+', label: '累计爆料' },
    { value: '50+', label: '专业编辑' },
    { value: '98%', label: '用户好评率' },
  ],
  testimonials: [
    {
      content: '自从关注了黑料不打烊，我成了朋友圈里的"八卦中心"。每次聚会大家都问我最近有什么瓜，哈哈！',
      author: '资深吃瓜群众',
      role: '平台早期用户',
    },
    {
      content: '更新速度真的快！有时候微博热搜还没上，这里已经有完整爆料了。编辑团队太强了。',
      author: '八卦小王',
      role: '忠实读者',
    },
    {
      content: '信息很全面，从明星到网红到体育圈都有。而且内容质量高，不像有些平台全是标题党。',
      author: '吃瓜不吃皮',
      role: 'VIP会员',
    },
  ],
  contact: {
    email: 'tips@hqsls.cn',
    wechat: 'heiliaobudayang',
    weibo: '@黑料不打烊官方',
    address: '北京市朝阳区光华路XX号',
  },
};

export const faqItems = [
  {
    question: '黑料不打烊的信息来源可靠吗？',
    answer: '我们拥有广泛的信息来源网络，包括娱乐记者、圈内人士、热心网友等。所有爆料在发布前都会经过编辑部至少两位编辑的审核和核实，确保信息的真实性。对于无法核实的信息，我们会明确标注"待核实"。',
  },
  {
    question: '如果我有爆料想要投稿，应该怎么做？',
    answer: '欢迎投稿！您可以将爆料内容发送至我们的官方邮箱 tips@hqsls.cn，或者通过微信公众号和微博私信提交。对于重要爆料，我们会有编辑与您联系核实。您的个人信息将严格保密。',
  },
  {
    question: '平台上的内容可以转载吗？',
    answer: '转载需注明出处"黑料不打烊"并保留原文链接。对于独家爆料内容，未经授权不得修改或删减原文内容。如有商业合作需求，请联系我们的商务团队。',
  },
  {
    question: '如果我发现平台上有不实信息怎么办？',
    answer: '我们非常重视信息的真实性。如果您发现平台上存在不实信息，请通过举报功能或联系我们的客服团队，我们会第一时间核实并处理。经核实确为不实信息的，我们会立即下架并发布更正声明。',
  },
];